import { render, staticRenderFns } from "./LiefengCascader.vue?vue&type=template&id=5d9d02b4&scoped=true&"
import script from "./LiefengCascader.vue?vue&type=script&lang=js&"
export * from "./LiefengCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d02b4",
  null
  
)

export default component.exports